import React from "react";
import {formatDate, parseBackendDateISO} from "../../../common/util/date";
import {serviceTypeMapping, scopeOfServiceMapping} from "referral";
import {capitalize} from "lodash";
import { ReferralOffer } from "./domain";

type Props = {
    offers: ReferralOffer[];
    onSelectOffer: (offer: ReferralOffer) => void;
};

function formatDisplayDate(isoStr: string | null | undefined): string {
    if (!isoStr) return "—";
    try {
        return formatDate(new Date(isoStr));
    } catch {
        return "—";
    }
}

function formatDisplaySfCalendarDate(isoStr: string | null | undefined): string {
    if (!isoStr) {
        return "—";
    }
    try {
        const parsed = parseBackendDateISO(isoStr);
        return parsed ? formatDate(parsed) : "—";
    } catch {
        return "—";
    }
}

export function ProviderReferralOfferTable({offers, onSelectOffer}: Props) {
    return (
        <div className="w-full">
            <table className="table-auto w-full border-collapse border border-gray-200 shadow-sm bg-white">
                <thead className="bg-gray-50 ">
                    <tr className="text-gray-portal-table-title text-sm">
                        <th className="p-3 text-left font-light">Referral ID</th>
                        <th className="p-3 text-left font-light">Service Type</th>
                        <th className="p-3 text-left font-light">Scope of Services</th>
                        <th className="p-3 text-left font-light">First Treatment Services Date</th>
                        <th className="p-3 text-left font-light">Requested</th>
                        <th className="p-3 text-left font-light">Accepted Date</th>
                        <th className="p-3 text-left font-light">Status</th>
                    </tr>
                </thead>
                <tbody className="text-sm">
                    {offers.map((offer) => (
                        <tr key={offer.guid} className="border-t border-gray-200 hover:bg-gray-50">
                            <td className="p-3">
                                <button
                                    onClick={() => onSelectOffer(offer)}
                                    className="text-blue-600 hover:underline font-medium text-left"
                                >
                                    {offer.referral.caseNumber}
                                </button>
                            </td>
                            <td className="p-3">{(offer.referral.serviceTypes || []).map(st => serviceTypeMapping[st] ?? st).join(", ")}</td>
                            <td className="p-3">{scopeOfServiceMapping[offer.referral.placementType] ?? offer.referral.placementType}</td>
                            <td className="p-3">{formatDisplaySfCalendarDate(offer.firstServiceDate)}</td>
                            <td className="p-3">{formatDisplayDate(offer.submittedAt)}</td>
                            <td className="p-3">{formatDisplayDate(offer.referral.matchedDate)}</td>
                            <td className="p-3">{capitalize(offer.status)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {offers.length === 0 && (
                <div className="text-center p-8 text-gray-500 bg-white border-t border-gray-200">
                    No referral offers available
                </div>
            )}
        </div>
    );
}
